/* eslint-disable import/prefer-default-export */
export enum StorageKeys {
    Email = 'email',
    Organization = 'organization',
    Type = 'userType',
    Logo = 'logoUrl',
    AuthProvider = 'authProvider',
}
